import axios from "axios";
import { createContext, useCallback, useContext, useEffect, useReducer } from "react"
import { useParams } from "react-router-dom";




const PropertyContext = createContext();

const serverUrl = 'https://osdevhub.com/homify_backend';

const initialState = {
    allPropertyData: [],
    topRatedPropertiesData: [],
    singleProperty: null,
    myProperties: null,
    propertyIsLoading: false,
    propertyErrorMessage: false,
    totalItems: null,
    totalPages: null


}

function reducer(state, action){
    switch (action.type){
        case 'loading':
            return{
                ...state,
                propertyIsLoading: true
            }
        case 'loaded':
            return{
                ...state,
                propertyIsLoading: false
            }
        case 'propertyError':
            return{
                ...state,
                propertyErrorMessage: action.payload
            }
        case 'allProperties':
            return{
                ...state,
                propertyIsLoading: false,
                allPropertyData: action.payload,
                
            }

        case 'topRatedProperties':
            return{
                ...state,
                propertyIsLoading: false,
                topRatedPropertiesData: action.payload,
                
            }

        case 'singleProperty':
            return{
                ...state,
                propertyIsLoading: false,
                singleProperty: action.payload
            }
        case 'myProperties':
            return{
                ...state,
                propertyIsLoading: false,
                myProperties: action.payload
            }
        case 'updateSuccess':
            return{
                ...state,
                propertyIsLoading: false,
            }
        case 'updatePropertyStatus':
            return{
                ...state,
                propertyIsLoading: false,
            }
        case 'saveSuccess':
            return{
                ...state,
                propertyIsLoading: false,
            }
        case 'paginatedProperties':
            return{
                ...state,
                propertyIsLoading: false,
                allPropertyData: action.payload.properties,
                totalItems: action.payload.totalItems,
                totalPages: action.payload.totalPages
            }
        case 'paginatedMyProperties':
            return{
                ...state,
                propertyIsLoading: false,
                myProperties: action.payload.properties,
                totalItems: action.payload.totalItems,
                totalPages: action.payload.totalPages
            }
      
        default:
            throw new Error("action unknown");
    }
  
}

function PropertyProvider({children}){
    const [{
        allPropertyData, 
        singleProperty, 
        myProperties, 
        propertyIsLoading, 
        propertyErrorMessage,
        topRatedPropertiesData,
        totalItems,
        totalPages
    
    }, dispatch] = useReducer(reducer, initialState);


    async function saveOneProperty(data) {
        dispatch({ type: 'loading' });
    
        try {
            const response = await axios.post(`${serverUrl}/api/properties`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data', 
                },
            });
    
            if (response.data.message === 'Property updated successfully') {
                dispatch({
                    type: 'saveSuccess',
                });
            }
        } catch (error) {
            dispatch({
                type: 'propertyError',
                payload: 'Error saving property'
            });
        }
    }


    async function fetchAllProperties() {
        dispatch({
            type:'loading'
        })
        try {
            const response = await axios.get(serverUrl + '/api/properties');
            if (response.data.message === 'Properties retrieved successfully') {
                dispatch({
                    type: 'allProperties',
                    payload: response.data.data
                })
            }
        } catch (error) {
            dispatch({
                type: 'propertyError',
                payload: 'there is an error'
            })
            console.error(error);
            
        }
    } 
    
    const fetchAllPropertiesPaginate = useCallback(    async function fetchAllPropertiesPaginate(data) {
        dispatch({
            type:'loading'
        })
        try {
            const response = await axios.get(`${serverUrl}/api/properties/paginate`, {
                    params: {
                        page: data.page || 1,
                        limit: data.limit || 9,
                        search: data.search,
                        priceRange: data.priceRange,
                        propertyType: data.propertyType
                    }
                });

            if (response.data.message === 'Properties retrieved successfully') {
                dispatch({
                    type: 'paginatedProperties',
                     payload: {
                    properties: response.data.data,
                    totalItems: response.data.totalItems, 
                    totalPages: response.data.totalPages 
                }
                })

                
            }
        } catch (error) {
            dispatch({
                type: 'propertyError',
                payload: 'there is an error'
            })
            console.error(error);
        }
    }, [] ) 


    async function fetchTopRatedProperties() {
        dispatch({
            type:'loading'
        })
        try {
            const response = await axios.get(serverUrl + '/api/properties/top-rated');
            if (response.data.message === 'Top 20 Properties retrieved successfully') {
                dispatch({
                    type: 'topRatedProperties',
                    payload: response.data.data
                })
            }
        } catch (error) {
            dispatch({
                type: 'propertyError',
                payload: 'there is an error'
            })
            console.error(error);
            
        }
    } 

    async function updateOneProperty(id, updatedData) {
        dispatch({ type: 'loading' });
    
        try {
            const response = await axios.put(`${serverUrl}/api/properties/${id}`, updatedData, {
                headers: {
                    'Content-Type': 'multipart/form-data', 
                },
            });
    
            if (response.data.message === 'Property updated successfully') {
                dispatch({
                    type: 'updateSuccess',
                });
            }
        } catch (error) {
            dispatch({
                type: 'propertyError',
                payload: 'Error updating property'
            });
        }
    }

   const fetchOneProperty = useCallback(   async function fetchOneProperty(id, user_id) {
    dispatch({
        type:'loading'
    })
    try {
     
        const response = await axios.get(`${serverUrl}/api/properties/${id}?user_id=${user_id}`);
        if (response.data.message === 'Property retrieved successfully') {
            dispatch({
                type: 'singleProperty',
                payload: response.data.data
            })
        }
    } catch (error) {
        dispatch({
            type: 'propertyError',
            payload: 'Error loading properties'
        })
    }
}, [])  


    const fetchMyProperties = useCallback( async function fetchMyProperties(id) {
        dispatch({
            type:'loading'
        })
        try {
        
            const response = await axios.get(`${serverUrl}/api/myproperties/${id}`);
            if (response.data.message === 'Properties retrieved successfully') {
                dispatch({
                    type: 'myProperties',
                    payload: response.data.data
                })
            }
            if(response.data.message === 'No properties found for this user'){
                dispatch({
                    type: 'myProperties',
                    payload: response.data.data
                })
            }
        } catch (error) {
            dispatch({
                type: 'propertyError',
                payload: 'Error fetching data'
            })
        }
    }, []
    ) 

    const fetchMyPropertiesPaginate = useCallback( async function fetchMyPropertiesPaginate(id, data) {
        dispatch({
            type:'loading'
        })
        try {
        
            const response = await axios.get(`${serverUrl}/api/myproperties/paginate/${id}`, {
                 params: {
                        page: data.page || 1,
                        limit: data.limit || 9,
                   
                    }
            });
            if (response.data.message === 'Properties retrieved successfully') {
                dispatch({
                    type: 'paginatedMyProperties',
                     payload: {
                    properties: response.data.data,
                    totalItems: response.data.totalItems, 
                    totalPages: response.data.totalPages 
                }
                })
            }
            if(response.data.message === 'No properties found for this user'){
                dispatch({
                    type: 'myProperties',
                    payload: response.data.data
                })
            }
        } catch (error) {
            dispatch({
                type: 'propertyError',
                payload: 'Error fetching data'
            })
        }
    }, []
    ) 

    async function deleteProperty(id) {
        dispatch({
            type:'loading'
        })
        try {
         
            const response = await axios.delete(`${serverUrl}/api/properties/${id}`);
            if (response.data.message === 'Property deleted successfully') {
                fetchMyProperties(id);
            }
        } catch (error) {
            dispatch({
                type: 'propertyError',
                payload: 'error'
            })
        }
    }

        async function updatePropertyStatus(id, data) {
      dispatch({ type: 'loading' });
      try {

        const response = await axios.patch(`${serverUrl}/api/propertystatus/${id}`, data);
        if(response.data.message === "Property updated successfully") {
          dispatch({
            type: 'updatePropertyStatus',
          })
        }
      } catch (error) {
        dispatch({
          type: 'propertyError',
          payload: error.response?.data?.message || error.message || 'Error fetching comments for property'
      });

      console.error(error);
        
      }

    }


    return <PropertyContext.Provider value={{
        allPropertyData, 
        singleProperty, 
        myProperties, 
        propertyIsLoading, 
        propertyErrorMessage,
        topRatedPropertiesData,
        totalItems,
        totalPages,
        fetchAllProperties, 
        fetchOneProperty, 
        fetchMyProperties, 
        deleteProperty, 
        updateOneProperty,
        saveOneProperty,
        fetchTopRatedProperties,
        fetchAllPropertiesPaginate,
        fetchMyPropertiesPaginate,
        updatePropertyStatus
        
        }}>
        {children}
        </PropertyContext.Provider>
}

function useProperty(){
    const context = useContext(PropertyContext);
    if(context === undefined) throw new Error("CommentContext must be used within a CommentProvider");
    
    return context
}

export {useProperty, PropertyProvider}